var map = {
	"./gallery_00.jpg": 1935,
	"./gallery_01.jpg": 1936,
	"./gallery_02.jpg": 1937,
	"./gallery_03.jpg": 1938,
	"./gallery_04.jpg": 1939,
	"./gallery_05.jpg": 1940,
	"./gallery_06.jpg": 1941,
	"./gallery_07.jpg": 1942,
	"./gallery_08.jpg": 1943,
	"./gallery_09.jpg": 1944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1934;